/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.line[_ngcontent-%COMP%]{display:flex;align-items:center}.flex-25[_ngcontent-%COMP%]{flex-basis:25%}.flex-75[_ngcontent-%COMP%]{flex-basis:75%}.flex-gap[_ngcontent-%COMP%]{flex-basis:10px}.per-month[_ngcontent-%COMP%]{margin-left:16px}.money-input[_ngcontent-%COMP%]{position:relative}.money-input[_ngcontent-%COMP%]::before{position:absolute;top:17px;left:20px;z-index:1;content:\"\u20AC\"}.money-input[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{padding-left:35px;max-width:180px}"];
export { styles as styles };
